<template>

  <!-- Table Container Card -->
  <b-card
    no-body
  >

    <div class="mx-1 my-1">
      <div class="text-center ">
        <!-- <h3 style="color: #756bea;">  Total Unpaid:   </h3> -->
      </div>
      <!-- Table Top -->
      <b-row>
        <!-- Per Page -->
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-0"
        >

          <label>Entries</label>
          <v-select
            v-model="perPage"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="perPageOptions"
            :clearable="false"
            class="per-page-selector d-inline-block ml-50 mr-1"
          />
        </b-col>

        <!-- Search -->
        <b-col
          cols="12"
          md="6"
        >
          <div class="d-flex align-items-center justify-content-end">
            <b-form-input
              v-model="searchQuery"
              class="d-inline-block mr-1"
              placeholder="Search..."
            />
            <v-select
              v-if="isMasterAdmin"
              v-model="ispIdFilter"
              :options="isp_list"
              placeholder="Select ISP"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              class="invoice-filter-select"
            >
              <template #selected-option="{ label }">
                <span class="text-truncate overflow-hidden">
                  {{ label }}
                </span>
              </template>
            </v-select>

            <v-select
              v-model="statusFilter"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="statusOptions"
              class="invoice-filter-select"
              placeholder="Select Status"
            >
              <template #selected-option="{ label }">
                <span class="text-truncate overflow-hidden">
                  {{ label }}
                </span>
              </template>
            </v-select>
          </div>
        </b-col>
      </b-row>

    </div>
    <div class="d-flex align-items-center flex-wrap mb-1 mx-1">
      <span class="mr-1">Total Selected Rows: {{ selected.length }}</span>
      <b-button class="btn btn-secondary btn-sm m-1" @click="selectAllRows">
        <span aria-hidden="true">&check;</span> All
      </b-button>
      <b-button class="btn btn-warning btn-sm m-1" :disabled="!selected.length" @click="clearSelected">X Clear</b-button>
      <b-button class="btn btn-success btn-sm m-1" :disabled="!selected.length" @click="paidSelectedInvoice">Make Paid</b-button>
      <b-button class="btn btn-info btn-sm m-1" :disabled="!selected.length" @click="unpaidSelectedInvoice">Make Unpaid</b-button>
      <b-button class="btn btn-danger btn-sm m-1" :disabled="!selected.length" @click="deleteSelectedInvoice">Delete</b-button>
    </div>
    <b-table
      ref="refInvoiceListTable"
      :items="fetchInvoices"
      responsive
      :fields="tableColumns"
      primary-key="id"
      :sort-by.sync="sortBy"
      :sort-compare="invoiceSortCompare"
      show-empty
      sort-icon-left
      empty-text="No matching records found"
      :sort-desc.sync="isSortDirDesc"
      class="position-relative table-compact"
      :select-mode="selectMode"
      selectable
      striped
      hover
      small
      head-variant="light"
      sticky-header="60vh"
      :no-local-sorting="true"
      @row-selected="onRowSelected"
    >
      <template #table-busy>
        <div class="text-center text-muted my-2">
          <b-spinner small class="mr-2" /> Loading...
        </div>
      </template>
      <template #head(selected)>
        <b-form-checkbox
          :checked="isAllVisibleSelected"
          :indeterminate="isSomeVisibleSelected"
          aria-label="Select all invoices"
          @click.stop
          @input="toggleSelectAll"
        />
      </template>
      <template #cell(selected)="data">
        <b-form-checkbox
          :checked="data.rowSelected"
          :aria-label="`Select invoice ${data.item && data.item.invoice_code ? data.item.invoice_code : ''}`"
          @click.stop
          @input="checked => toggleRowSelection(data.index, checked)"
        />
      </template>
      <template #head(invoiceStatus)>
        <feather-icon
          icon="TrendingUpIcon"
          class="mx-auto"
        />
      </template>

      <!-- Column: Id -->
      <template #cell(invoice_code)="data">
        <b-link
          :to="{ name: 'isp-invoice-preview', params: { invoiceId: data.item.id }}"
          class="font-weight-bold text-primary"
        >
          {{ data.value }}
        </b-link>
      </template>
      <!-- Column: payment_status Date -->
      <template #cell(payment_status_value)="data">
        <template v-if="data.value === 'Paid' ">
          <b-badge
            pill
            variant="light-success"
          >
            {{ data.value }}
          </b-badge>
        </template>
        <template v-else>
          <b-badge
            pill
            variant="light-warning"
          >
            {{ data.value }}
          </b-badge>

        </template>
      </template>

      <!-- Column: User (Name only with avatar) -->
      <template #cell(user)="data">
        <b-media vertical-align="center">
          <template #aside>
            <b-avatar
              size="24"
              :src="data.item.user.image_path"
              :text="avatarText(data.item.user.name)"
              :variant="`light-${resolveClientAvatarVariant(data.item.user.payment_status_value)}`"
            />
          </template>
          <span class="font-weight-bold d-block text-nowrap text-dark">
            {{ data.item.user.name }}
          </span>
        </b-media>
      </template>

      <!-- Column: Username -->
      <template #cell(isp_user_name)="data">
        <span class="text-nowrap text-dark font-weight-bold">
          {{ data.item.isp_user_name || '-' }}
        </span>
      </template>
      <!-- Column: Bill -->
      <template #cell(grand_total)="data">
        <span :class="['font-weight-bold', data.item.payment_status_value === 'Paid' ? 'text-success' : 'text-danger']">
          {{ data.value }}
        </span>
      </template>

      <!-- Column: invoice_date Date -->
      <template #cell(invoice_date)="data">
        <span class="text-nowrap text-secondary">
          {{ data.value }}
        </span>
      </template>
      <!-- Column: last_payment_date Date -->
      <template #cell(last_payment_date)="data">
        <span class="text-nowrap text-secondary">
          {{ data.value }}
        </span>
      </template>
      <!-- Column: paid_date Date -->
      <template #cell(paid_date)="data">
        <span class="text-nowrap text-secondary">
          {{ data.value }}
        </span>
      </template>

      <!-- Column: paid_date Date -->
      <template #cell(payment_method)="data">
        <span class="text-nowrap text-dark">
          {{ data.value }}
        </span>
      </template>

      <!-- Column: payment_note -->
      <template #cell(payment_note)="data">
        <span
          class="text-truncate d-inline-block text-dark"
          style="max-width: 220px;"
          :title="data.value || ''"
        >
          {{ data.value || '-' }}
        </span>
      </template>

      <!-- Column: Actions -->
      <template #cell(actions)="data">

        <div class="text-nowrap">

          <feather-icon
            :id="`invoice-row-${data.item.id}-preview-icon`"
            icon="EyeIcon"
            size="16"
            class="mx-1"
            @click="$router.push({ name: 'isp-invoice-preview', params: { invoiceId: data.item.id }})"
          />
          <b-tooltip
            title="Preview Invoice"
            :target="`invoice-row-${data.item.id}-preview-icon`"
          />
          <b-button
            variant="link"
            size="sm"
            class="px-0 align-baseline"
            @click="$router.push({ name: 'isp-invoice-preview', params: { invoiceId: data.item.id }})"
          >
            Detail
          </b-button>
        </div>
      </template>

    </b-table>
    <div class="mx-1 my-1">
      <b-row>

        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-start"
        >
          <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
        </b-col>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-end"
        >

          <b-pagination
            v-model="currentPage"
            :total-rows="totalInvoices"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>

        </b-col>

      </b-row>
    </div>
  </b-card>

</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BPagination, BTooltip, BSpinner, BFormCheckbox,
} from 'bootstrap-vue'
import { avatarText } from '@core/utils/filter'
import vSelect from 'vue-select'
import { onUnmounted } from '@vue/composition-api'
import store from '@/store'
import { ISP_LIST } from '@core/services/api'
import Mixin from '@core/services/mixin'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import useJwt from '@/auth/jwt/useJwt'
import { checkRes } from '@core/services/helper'
import invoiceStoreModule from '../invoiceStoreModule'
import useInvoicesList from './useInvoiceList'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BPagination,
    BTooltip,
    BSpinner,
    BFormCheckbox,

    vSelect,
  },
  mixins: [Mixin],

  data() {
    return {
      selectMode: 'multi',
      selected: [],
    }
  },
  computed: {
    visibleRowCount() {
      const t = this.$refs.refInvoiceListTable
      return t && t.localItems ? t.localItems.length : 0
    },
    isAllVisibleSelected() {
      return this.visibleRowCount > 0 && this.selected.length === this.visibleRowCount
    },
    isSomeVisibleSelected() {
      return this.selected.length > 0 && this.selected.length < this.visibleRowCount
    },
  },
  setup() {
    //  const isp_list = [];
    // console.log(fetchInvoices);
    const INVOICE_APP_STORE_MODULE_NAME = 'app-invoice'

    // Register module
    if (!store.hasModule(INVOICE_APP_STORE_MODULE_NAME)) store.registerModule(INVOICE_APP_STORE_MODULE_NAME, invoiceStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(INVOICE_APP_STORE_MODULE_NAME)) store.unregisterModule(INVOICE_APP_STORE_MODULE_NAME)
    })

    const statusOptions = [
      { value: null, label: 'All' },
      { value: 1, label: 'Paid' },
      { value: 0, label: 'Unpaid' },
    ]
    const userData = JSON.parse(localStorage.getItem('userData'))
    const isMasterAdmin = !!(
      userData && Array.isArray(userData.roles) && userData.roles[0] && userData.roles[0].name === 'Master Admin'
    )
    const {
      fetchInvoices,
      tableColumns,
      perPage,
      currentPage,
      totalInvoices,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refInvoiceListTable,
      // unpaid_amount,
      statusFilter,
      ispIdFilter,
      refetchData,

      resolveInvoiceStatusVariantAndIcon,
      resolveClientAvatarVariant,
    } = useInvoicesList()

    // Default status filter to "All"
    if (statusFilter && typeof statusFilter === 'object' && 'value' in statusFilter) {
      statusFilter.value = statusOptions[0]
    }

    return {
      fetchInvoices,
      tableColumns,
      perPage,
      currentPage,
      totalInvoices,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refInvoiceListTable,

      statusFilter,
      ispIdFilter,
      // unpaid_amount,
      refetchData,

      statusOptions,
      isp_list: [],
      avatarText,
      resolveInvoiceStatusVariantAndIcon,
      resolveClientAvatarVariant,
      userData,
      isMasterAdmin,
    }
  },
  mounted() {
    this.idpListData()
  },
  methods: {
    invoiceSortCompare(a, b, key, sortDesc, formatter, compareOptions, compareLocale) {
      if (key === 'user') {
        const an = (a.user && a.user.name) ? a.user.name : ''
        const bn = (b.user && b.user.name) ? b.user.name : ''
        const res = an.localeCompare(bn, undefined, { sensitivity: 'base' })
        return res
      }
      // Fallback to default comparison for other fields
      return null
    },
    toggleSelectAll(checked) {
      if (!this.$refs.refInvoiceListTable) return
      if (checked) this.$refs.refInvoiceListTable.selectAllRows()
      else this.$refs.refInvoiceListTable.clearSelected()
    },
    toggleRowSelection(index, checked) {
      if (!this.$refs.refInvoiceListTable) return
      if (checked) this.$refs.refInvoiceListTable.selectRow(index)
      else this.$refs.refInvoiceListTable.unselectRow(index)
    },
    idpListData() {
      this.$http
        .get(process.env.VUE_APP_BASEURL + ISP_LIST)
        .then(res => {
          console.log('invoice isp list', res.data.data)
          this.isp_list = res.data.data
        })
        .catch(() => {
          // Silently ignore ISP list load errors for now
        })
    },
    onRowSelected(items) {
      this.selected = items.map(s => s.id)
    },
    selectAllRows() {
      this.$refs.refInvoiceListTable.selectAllRows()
    },
    clearSelected() {
      this.$refs.refInvoiceListTable.clearSelected()
    },
    paidSelectedInvoice() {
      console.log('paidSelectedInvoice')
      if (this.selected.length <= 0) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Invoice Payment',
            icon: 'CoffeeIcon',
            variant: 'warning',
            text: 'No invoices selected. Select at least one invoice.',
          },
        })
        return true
      }
      if (window.confirm('Are you sure you want to paid following invoice?')) {
        // Delete the item logic here
        console.log('Item deleted!')
        console.log(this.selected)
        useJwt.bulkPaidInvoice({
          invoice_ids: this.selected ?? null,
        })
          .then(response => {
            if (checkRes(response.status) && response.data.data) {
              this.$refs.refInvoiceListTable.refresh()
              this.$router
                .push({ name: 'isp-invoice-list' })
                .catch(success => {
                  this.toastMessage('success', 'Invoice Payment', response)
                })
            } else {
              this.$router
                .push({ name: 'isp-invoice-list' })
                .then(() => {
                  this.toastMessage('warning', 'Invoice Payment', response)
                })
                .catch(error => {
                  this.toastMessage('danger', 'Invoice Payment', response)
                })
            }
          })
      } else {
        console.log('Deletion cancelled.')
      }
    },
    unpaidSelectedInvoice() {
      console.log('unpaidSelectedInvoice')
      if (this.selected.length <= 0) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Invoice Payment',
            icon: 'CoffeeIcon',
            variant: 'warning',
            text: 'No invoices selected. Select at least one invoice.',
          },
        })
        return true
      }
      if (window.confirm('Are you sure you want to unpaid following invoice?')) {
        console.log('Item unpaidSelectedInvoice!')
        console.log(this.selected)
        useJwt.bulkUnpaidInvoice({
          invoice_ids: this.selected ?? null,
        }).then(response => {
          if (checkRes(response.status) && response.data.data) {
            this.$refs.refInvoiceListTable.refresh()
            this.$router
              .push({ name: 'isp-invoice-list' })
              .catch(success => {
                this.toastMessage('success', 'Invoice', response)
              })
          } else {
            this.$router
              .push({ name: 'isp-invoice-list' })
              .then(() => {
                this.toastMessage('warning', 'Invoice', response)
              })
              .catch(error => {
                this.toastMessage('danger', 'Invoice', response)
              })
          }
        })
      } else {
        console.log('Deletion unpaid.')
      }
    },
    deleteSelectedInvoice() {
      console.log('deleteSelectedInvoice')
      if (this.selected.length <= 0) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Invoice Deletion',
            icon: 'CoffeeIcon',
            variant: 'warning',
            text: 'No invoices selected. Select at least one invoice.',
          },
        })
        return true
      }
      console.log(this.selected)
      if (window.confirm('Are you sure you want to delete following invoice?')) {
        // Delete the item logic here
        console.log('Item deleted!')
        console.log(this.selected)
        useJwt.deleteInvoiceById({
          invoice_ids: this.selected ?? null,
        })
          .then(response => {
            if (checkRes(response.status) && response.data.data) {
              this.$refs.refInvoiceListTable.refresh()
              this.$router
                .push({ name: 'isp-invoice-list' })
                .catch(success => {
                  this.toastMessage('success', 'Invoice', response)
                })
            } else {
              console.log(response)
              this.$router
                .push({ name: 'isp-invoice-list' })
                .then(() => {
                  this.toastMessage('warning', 'Invoice', response)
                })
                .catch(error => {
                  this.toastMessage('danger', 'Invoice', response)
                })
            }
          })
      } else {
        console.log('Deletion delete.')
      }
    },
  },
  // mounted(){
  //    let instance = this;
  //    $("#ispListId").change(function () {
  //           this.isp_id=  $(this).children("option:selected").val();
  //           instance.fetchInvoices(null,null,this.isp_id)
  //           console.log('invoice'+ this.isp_id);
  //   });
  // }
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.invoice-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}

/* Table readability: standard font + spacing */
::v-deep .table-compact table {
  font-size: 1.05rem; /* bumped from 0.95rem */
}
::v-deep .table-compact table thead th,
::v-deep .table-compact table tbody td {
  padding: 0.5rem 0.75rem; /* was 0.25rem 0.45rem */
  white-space: nowrap;
}

/* Sticky right column for actions */
::v-deep .sticky-right {
  position: sticky;
  right: 0;
  z-index: 3;
  background: #fff;
  box-shadow: -1px 0 0 rgba(0, 0, 0, 0.05);
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
